export type SynergyLogoVariant =
  | 'main'
  | 'monochrome'
  | 'reverse'
  | 'standalone';

const brandingRoot = `${process.env.PUBLIC_URL}/img/branding`;

export const synergyLogos: Record<SynergyLogoVariant, string> = {
  main: `${brandingRoot}/main_logo.png`,
  monochrome: `${brandingRoot}/monochrome_logo.png`,
  reverse: `${brandingRoot}/reverse_logo_white.png`,
  standalone: `${brandingRoot}/standalone_icon.png`,
};
